/**
 * Magyar adószámot egészít ki, validál
 * @author adamcsabi
 */
import taxNumberValidation from '../utils/validation/tax-number';

export default function(app) {
	app.directive('taxNumber', function () {
		return {
			scope: {
				taxNumberValue: '=',
				editOnlyLastChars: '=',
				notHungarian: '='
			},
			restrict: 'A',
			require: 'ngModel',
			link: function (scope, elem, attrs, ctrl) {
				var required = attrs.required || false;

				scope.$watch('taxNumberValue', function (newValue, oldValue) {
					var disableFormatting = attrs.disableFormatting;

					if (newValue && newValue.length > 13 && !scope.notHungarian) {
						var taxNumberFitPattern = taxNumberValidation(scope.taxNumberValue, required);
						ctrl.$setValidity('taxNumberFormat', taxNumberFitPattern);

						scope.taxNumberValue = scope.taxNumberValue.substr(0, 13);
						return;
					}

					if (!scope.notHungarian) {
						// Magyar adószám
						if (!newValue && scope.editOnlyLastChars || newValue && newValue.length < 9 && scope.editOnlyLastChars) {
							scope.taxNumberValue = oldValue;
						}

						if (newValue && oldValue && disableFormatting !== 'true') {
							if ((newValue.length == 8 && oldValue.length == 7) || (newValue.length == 10 && oldValue.length == 9)) {
								scope.taxNumberValue = newValue + '-';
							} else if ((newValue.length == 10 && oldValue.length == 11) || (newValue.length == 8 && oldValue.length == 9)) {
								scope.taxNumberValue = newValue.slice(0, -1);
							}
						}
					} else {
						// Nem magyar adószám, nem kell formázni

						scope.taxNumberValue = newValue;
						ctrl.$setValidity('taxNumberFormat', true);
					}

					if (disableFormatting === 'true') {
						ctrl.$setValidity('taxNumberFormat', true);
					} else {
						if (scope.notHungarian) {
							ctrl.$setValidity('taxNumberFormat', true);
						} else {
							var fitPattern = taxNumberValidation(scope.taxNumberValue, required);
							ctrl.$setValidity('taxNumberFormat', fitPattern);
						}
					}
				});

			}
		};
	});
};
